import {vnTemplate} from "../../../../valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

interface DownloadOptions {
    forceExtension?: string
}
export class imagePickerView_template extends vnTemplate {

    private static readonly ONE_DAY = 86400000 //One day in milliseconds

    protected parent: any;

    protected getTemplateHtml(): string {

        return /* html */`
             <div class="w-img-picker-view" data-bind="css: { 'is-visible': isShown }">

                <div class="img-picker-view">
                    <div class="view-header">
                        <strong data-bind="text: name"></strong>
                        <button type="button" class="close-btn icon i-close" data-bind="event: { click: onClickCancel }"></button>
                    </div>
                    <div class="view-body center">

                        <div class="view-img-container" data-bind="css: {'is-optimized' : isMobileOptimized()}">
                            <div class="w-img-optimization">
                                <span>Mobile Optimization Preview</span>
                                <div class="img-optimization-overlay"></div>
                                <div class="img-optimization-crop"></div>
                                <div class="img-optimization-overlay"></div>
                            </div>
                            <img data-bind="attr: {src: fileUrl }">
                        </div>

                         <div class="view-footer">

                            <div>
                                <button class="btn-icon icon accent i-delete" title="Delete" type="button" data-bind="event: { click: onClickDelete }, css: { 'is-disable': imageIsOlderThan24Hours($data) }">
                                    <span>Delete</span>
                                </button>
                                <button class="btn-icon icon i-download" title="Download" type="button" data-bind="event: { click: onClickDownload }">
                                    <span>Download</span>
                                </button>
                                <button class="btn-icon icon i-select" title="Select" type="button" data-bind="event: { click: onClickSelect}">
                                    <span>Select</span>
                                </button>
                                <button class="btn-icon icon i-full-size" title="View Original" type="button" data-bind="event: { click: onClickViewOriginal }">
                                    <span>View Original</span>
                                </button>
                                <button class="btn-icon icon i-mobile" title="Mobile Optimized Preview" type="button" data-bind="css: {'is-hidden': !isImageOptimizable() || !isLandscape() || isWaterMark(), 'is-activated': isMobileOptimized()}, event: { click: onClickOptimizedMobileToggle }">
                                    <span>Mobile Optimized Preview</span>
                                </button>
                            </div>
                            <div>
                                <div class="insert-dropdown">
                                    <button class="btn-icon insert-dropdown-toggle i-dropdown-simple icon i-ins" type="button"><span>Insert</span></button>
                                    <div class="insert-dropdown-list">
                                        <button class="btn-icon icon i-ins-ind" type="button" data-bind="event: { click: onClickInsert.bind($parent, '') }" title="Insert Individually" type="button"><span>Individually</span></button>
                                        <button class="btn-icon icon i-ins-gallery is-disable" title="Insert Group" type="button"><span>Insert as Gallery</span></button>
                                        <button class="btn-icon icon i-ins-grid" data-bind="event: { click: onClickInsert.bind($parent, $parent.isInsertAsGrid()) }, visible: $parent.mode() == 'multi-select'" title="Insert as Grid" type="button"><span>Insert as Grid</span></button>
                                    </div>
                                </div>
                                <!--
                                <div class="btn-icon-joint">
                                    <button class="btn-icon icon i-insert" title="Insert" type="button" data-bind="event: { click: onClickInsert.bind($parent, '') }"><span>Quick Insert</span></button>
                                    <button class="btn-icon icon i-insert-grid" title="Insert as Grid" type="button" data-bind="event: { click: onClickInsert.bind($parent, $parent.isInsertAsGrid()) }, visible: $parent.mode() == 'multi-select'"><span>Insert as Grid</span></button>
                                </div>
                                -->
                                <button class="btn-icon icon i-add-to-gallery" title="Add to Group" type="button" data-bind="event: { click: onClickAddToGallery }, visible: $parent.mode() == 'multi-select' "><span>Add to Group</span></button>
                                <button class="btn-icon icon i-edit" title="Edit" type="button" data-bind="event: { click: onClickEdit }"><span>Edit</span></button>

                            </div>
                        </div>

                        <div class="w-view-info">

                            <dl class="view-info double-list">
                                <dt><span>ratio</span></dt>
                                <dd><span data-bind="text: ratio"></span></dd>
                                <dt data-bind="if: permissions()['article_edit_embargo'].write"><span>Under Embargo</span></dt>
                                <dd data-bind="if: permissions()['article_edit_embargo'].write"><span data-bind="text: (isUnderEmbargo() ? 'Yes' : 'No')"></span></dd>
                                <dt><span>mime</span></dt>
                                <dd><span data-bind="text: mimeType"></span></dd>
                                <dt><span>dimension</span></dt>
                                <dd><span class="lower-case"data-bind="text: width()+ 'px' + ' x ' + height() + 'px'"></span></dd>
                                <dt><span>file size</span></dt>
                                <dd><span data-bind="text: fileSize"></span></dd>
                                <dt><span>Watermarked</span></dt>
                                <dd><span data-bind="text: (isWaterMark() ? 'Yes' : 'No')"></span></dd>
                                <dt><span>Mobile Optimized</span></dt>
                                <dd><span data-bind="text: (isMobileOptimized() ? 'Yes' : 'No')"></span></dd>
                                <dt><span>Enhanced</span></dt>
                                <dd><span data-bind="text: isAiTouched()"></span></dd>
                                <dt class="full-width">
                                    <span>Tags</span>
                                </dt>
                                <dd class="full-width">
                                    <!-- ko if: !imageTags() || imageTags().length == 0 -->
                                        <span class="no-cap"
                                            data-bind="text: 'None'"
                                        ></span>
                                    <!-- /ko -->
                                    <!-- ko foreach: imageTags -->
                                        <div class="no-cap"
                                            data-bind="
                                                text: $data.tag.idType? $data.tag.name + ' ' + $data.tag.formattedTagTypeAndDataset : $data.tag.name,
                                                style: { 'font-weight': $parent.isTagIdPrimaryTag($data.tag.id)? 'bold' : 'normal' }
                                            "
                                        ></div>
                                    <!-- /ko -->
                                </dd>
                                <dt class="full-width" style="text-transform: uppercase;font-weight: 700"><span>Alt</span></dt>
                                <!-- ko if: altText -->
                                 <dd class="full-width"><span data-bind="text: altText"></span></dd>
                                <!-- /ko -->
                                <!-- ko ifnot: altText -->
                                <dd class="full-width"><span>None</span></dd>
                                <!-- /ko -->

                            </dl>
                            <div class="view-info">
                                <strong class="title">Credit Text</strong>

                                <!-- ko if: caption -->
                                <p data-bind="html: caption"></p>
                                <!-- /ko -->
                                <!-- ko ifnot: caption -->
                                <p>None</p>
                                <!-- /ko -->

                                <strong class="title">Description</strong>
                                <!-- ko if: description -->
                                <p data-bind="html: description"></p>
                                <!-- /ko -->
                                <!-- ko ifnot: description -->
                                <p>None</p>
                                <!-- /ko -->
                            </div>
                        </div>
                    </div>

                </div>

            </div>
            `;
    }

    private onLoadTemplate () {

    }

    public getViewModelForRequest(){

        return {
             filters      : {
                keywords: this.getTemplateViewModel().filterSimple.filterKeyword,
            },
        }
    }



    protected initPartial(): void {

    }

    protected getTemplateName(): string {
        return "imagePickerView-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected buildViewModel(): any {

        //create observable array refresh function
        ko.observableArray.fn.refresh = function (item, index) {
            if (index==null) index = this['indexOf'](item);
            if (index >= 0) {
                this.splice(index, 1, ko.utils.extend({}, item)) // create new item
            }
        }

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return {
            isShown: ko.observable(false),
            name: ko.observable(null),
            mode: ko.observable("multi-select"),
            idImage: ko.observable(null),
            caption: ko.observable(null),
            description: ko.observable(null),
            altText: ko.observable(null),
            dateCreated: ko.observable(null),
            width: ko.observable(null),
            height: ko.observable(null),
            selectedImage: ko.observable(null),
            fileSize: ko.observable(null),
            ratio: ko.observable(null),
            mimeType: ko.observable(null),
            isUnderEmbargo: ko.observable(false),
            isWaterMark: ko.observable(false),
            isMobileOptimized: ko.observable(true),
            isLandscape: ko.observable(false),
            isPortrait: ko.observable(false),
            isSquare: ko.observable(false),
            isImageOptimizable:  ko.observable(false),
            permissions: ko.observableArray(this.initPermissions(['article_edit_embargo'])),
            fileUrl: ko.observable(null),
            isAiEnhanced: ko.observable(true),
            isHdrAdjusted: ko.observable(true),
            idPrimaryTag: ko.observable(null),
            primaryTag: ko.observable(null),
            imageTags: ko.observableArray([]),
            onClickCancel: function(data, event){ huit_neuf_this.onClickCancel();},
            onLoadTemplate: function(data, event){ huit_neuf_this.onLoadTemplate();},
            onClickInsert: function(param, data, event){ huit_neuf_this.onClickInsert(param, data);},
            onClickEdit: function(data, event){ huit_neuf_this.onClickEdit();},
            onClickDownload: function(data, event){ huit_neuf_this.onClickDownload();},
            onClickViewOriginal: function(data, event){ huit_neuf_this.onClickViewOriginal();},
            onClickDelete: function(data, event){ huit_neuf_this.onClickDelete();},
            onClickSelect: function(data, event){ huit_neuf_this.onClickSelect();},
            onClickAddToGallery: function(data, event){ huit_neuf_this.onClickAddToGallery();},
            imageIsOlderThan24Hours: function (data, event){ return huit_neuf_this.imageIsOlderThan24Hours(data);},
            onClickOptimizedMobileToggle: function(data, event){ huit_neuf_this.onClickOptimizedMobileToggle();},
            isTagIdPrimaryTag: (tagId) => huit_neuf_this.getTemplateViewModel().primaryTag()? tagId === huit_neuf_this.getTemplateViewModel().primaryTag().id : false,
            isAiTouched: function () {
                let anyIsOn = false;
                let whichIsOn = [];
                if (this.isAiEnhanced()) {
                    whichIsOn.push('Upscaled');
                    anyIsOn = true;
                }

                if (this.isHdrAdjusted()) {
                    whichIsOn.push('HDR Color Adjusted');
                    anyIsOn = true;
                }

                if (!anyIsOn) {
                    return "No";
                } else {
                    return `Yes (${whichIsOn.join(', ')})`;
                }
            },
};
    }

    protected onClickCancel(){

        this.hide();
    }

    public setIsImageOptimizable(isImageOptimizable: boolean): void {
        this.getTemplateViewModel().isImageOptimizable(isImageOptimizable);
    }

    public isImageOptimizable(): boolean {
        return this.getTemplateViewModel().isImageOptimizable();
    }

    public setParent(parent){

        this.parent = parent;
    }

    protected onClickEdit(){
        this.parent.editImage(this.getImage());
        //this.hide();
    }

    protected onClickAddToGallery(){

        this.parent.addToGallery(this.getImage());
        this.hide();
    }


    protected onClickSelect(){
        let image = this.getImage();
        image.selected = true;
        this.parent.selectImage(image);
        this.hide();
    }

    protected onClickDelete(){

        this.parent.deleteImage(this.getImage());
        this.hide();
    }

    protected onClickDownload(){

        let url = this.getTemplateViewModel().fileUrl().split("?")[0];
        let name = this.getTemplateViewModel().name();
        this.downloadFile(url, name, { forceExtension: 'avif'});
    }

    protected onClickViewOriginal(){

        let url = this.getTemplateViewModel().fileUrl().split("?")[0];
        let name = this.getTemplateViewModel().name();
        this.getFile(url, name, false);
    }


    protected onClickOptimizedMobileToggle(): void {
        let isMobileOptimized = this.getTemplateViewModel().isMobileOptimized();

        this.getTemplateViewModel().isMobileOptimized(!isMobileOptimized);
    }

    protected downloadFile(fileUrl, name, options: DownloadOptions = {}){
        /*, {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            mode: 'no-cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached// include, *same-origin, omit
            headers: {
                'Content-Disposition': 'attachment'
            }}*/


        fetch(fileUrl)
            .then(resp => resp.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                let extension = fileUrl.split('.').pop();

                if(options.forceExtension){
                    extension = options.forceExtension;
                }
                // the filename you want
                a.download = name + '.' + extension;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                //alert('your file has downloaded!'); // or you know, something with better UX...
            })
            .catch(() => alert('file download failed!'));
    }

    protected getFile(url, name, download){

        var element = document.createElement('a');
        element.setAttribute('href', url);
        if(download){
            let extension = url.split('.').pop();
            element.setAttribute('download', name + '.' + extension);
        }else{
            element.setAttribute('target', '_blank');
        }
        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    }

    protected getImage(){

        let viewModel = this.getTemplateViewModel();

        let image = {
            id: viewModel.idImage(),
            url: viewModel.fileUrl() ,
            name: viewModel.name(),
            caption: viewModel.caption(),
            description: viewModel.description(),
            altText: viewModel.altText(),
            width: viewModel.width(),
            height: viewModel.height(),
            fileSize: viewModel.fileSize(),
            ratio: viewModel.ratio(),
            mimeType: viewModel.mimeType(),
            isUnderEmbargo: viewModel.isUnderEmbargo(),
            isWaterMark: viewModel.isWaterMark(),
            isMobileOptimized: viewModel.isMobileOptimized(),
            isLandscape: viewModel.isLandscape(),
            isPortrait: viewModel.isPortrait(),
            isSquare: viewModel.isSquare(),
            selected: false,
            isAiEnhanced: viewModel.isAiEnhanced(),
            isHdrAdjusted: viewModel.isHdrAdjusted(),
            imageTags: viewModel.imageTags(),
            primaryTag: viewModel.primaryTag(),
        };

        return image;
    }

    protected onClickInsert(param, data){

        let image = this.getImage();

        if (param != '' || image.isWaterMark || !image.isLandscape || !this.isImageOptimizable()) {

            image.isMobileOptimized = false;
        }

        this.parent.insertImage(image, param);
        this.hide();
    }


    /*public addImageToResults(image){
        let results = this.getTemplateViewModel().imageResults;
        results().unshift(image);
        results.refresh(image,0);
        this.setSelectedImage(image);
    }*/


    public setImage(image){

        if(image){
            const primaryTag =
                image.details && image.details !== null && image.details.idPrimaryTag !== null
                    ? image.details.primaryTag
                    : null;
            this.getTemplateViewModel().idImage(image.id);
            this.getTemplateViewModel().name(image.name);
            this.getTemplateViewModel().caption(image.caption);
            this.getTemplateViewModel().description(image.description);
            this.getTemplateViewModel().altText(image.altText);
            this.getTemplateViewModel().dateCreated(image.dateCreated);
            this.getTemplateViewModel().width(image.width);
            this.getTemplateViewModel().height(image.height);
            this.getTemplateViewModel().fileSize(image.fileSize);
            this.getTemplateViewModel().ratio(image.ratio);
            this.getTemplateViewModel().mimeType(image.mimeType);
            this.getTemplateViewModel().isUnderEmbargo(image.isUnderEmbargo);
            this.getTemplateViewModel().isWaterMark(image.isWaterMark);
            this.getTemplateViewModel().isMobileOptimized((!image.isWaterMark && image.isLandscape && this.isImageOptimizable()));
            this.getTemplateViewModel().isLandscape(image.isLandscape);
            this.getTemplateViewModel().isPortrait(image.isPortrait);
            this.getTemplateViewModel().isSquare(image.isSquare);
            this.getTemplateViewModel().fileUrl(image.url.split("?")[0]);
            this.getTemplateViewModel().isAiEnhanced(image.isAiEnhanced);
            this.getTemplateViewModel().isHdrAdjusted(image.isHdrAdjusted);
            // set the primary tag first.
            this.getTemplateViewModel().primaryTag(primaryTag);
            this.getTemplateViewModel().imageTags(image.imageTags? image.imageTags : []);
            this.getTemplateViewModel().idPrimaryTag(primaryTag? primaryTag.id : null);
        }

    }


    public show(){

        this.getTemplateViewModel().isShown(true);
    }

    public hide(){

        this.getTemplateViewModel().isShown(false);
    }

    public getIsShown(){

        return this.getTemplateViewModel().isShown();
    }

    public setMode(mode){

       this.getTemplateViewModel().mode(mode)
    }

    public setImageTags(imageTags): void {
        this.getTemplateViewModel().imageTags(imageTags);
    }

    public setPrimaryTag(primaryTag): void {
        this.getTemplateViewModel().primaryTag(primaryTag);
    }

    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions)
    }

    public imageIsOlderThan24Hours(data): boolean {

        let now : any = new Date()
        let imageCreationDate : any = new Date(data.dateCreated())

        return (now - imageCreationDate > imagePickerView_template.ONE_DAY)
    }
}



// WEBPACK FOOTER //
// ./vendor/valnet/valnet_imagePicker/js/components/templates/imagePickerView_template.ts